"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
const styles = ({ typography, palette }) => ({
    tooltip: {
        fontSize: typography.caption.fontSize,
        background: palette.tooltip.dark,
        color: palette.tooltip.contrastText,
    },
});
exports.styles = styles;
